import type {ServiceResponsePayload} from '@igp/shared/api';
import type {DebtResponsibleMasterAgent} from '@igp/shared/contract/pam';
import {createAsyncAction} from 'typesafe-actions';

import type {AddDebtResponsibleMasterPayload, RemoveDebtResponsibleMasterPayload} from './types';

const domain = 'debt-responsible-master-agent' as const;

export const debtResponsibleMasterAgentActions = {
    addAgent: createAsyncAction(`${domain}/addAgentRequest`, `${domain}/addAgentSuccess`, `${domain}/addAgentFailure`)<
        AddDebtResponsibleMasterPayload,
        ServiceResponsePayload<AddDebtResponsibleMasterPayload, DebtResponsibleMasterAgent>,
        ServiceResponsePayload<AddDebtResponsibleMasterPayload, DebtResponsibleMasterAgent>
    >(),
    removeAgent: createAsyncAction(`${domain}/removeAgentRequest`, `${domain}/removeAgentSuccess`, `${domain}/removeAgentFailure`)<
        RemoveDebtResponsibleMasterPayload,
        ServiceResponsePayload<RemoveDebtResponsibleMasterPayload, DebtResponsibleMasterAgent>,
        ServiceResponsePayload<RemoveDebtResponsibleMasterPayload, DebtResponsibleMasterAgent>
    >(),
};
